import styled from "styled-components";

const GiveNowButton = styled.button`
  background-color: #2f80ed;
  border-radius: 4px;
  color: #f2f2f2;
  padding: 6px;
`;

export default GiveNowButton;
